var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboardSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1375_16320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5519C13.5 18.0319 13.12 18.4119 12.64 18.4119H1.36C0.89 18.4119 0.5 18.0219 0.5 17.5519V9.28188C0.5 8.80188 0.88 8.42188 1.36 8.42188H12.64C13.11 8.42188 13.5 8.81188 13.5 9.28188V17.5519Z",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03027 5.42969H15.6703C16.1403 5.42969 16.5303 5.80969 16.5303 6.28969V15.8997",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05005 2.5H18.74C19.21 2.5 19.59 2.89 19.59 3.36V12.88",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6095 8.42188H1.39953C0.909531 8.42188 0.519531 8.82188 0.519531 9.30188V10.9019H13.4895V9.30188C13.4895 8.81188 13.0895 8.42188 12.6095 8.42188Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1375_16320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.09,
    height: 16.91,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardSequence);
export default __webpack_public_path__ + "static/media/icon-dashboard-sequence.c48fc07b5725891537380cdbd1a82f37.svg";
export { ForwardRef as ReactComponent };